<template lang="html">
</template>

<script>
import MaterialCard from '@/components/material/Card';

export default {
  components: {
    MaterialCard
  }
}
</script>

<style lang="css" scoped>
</style>
